import { io } from "socket.io-client";

const token = localStorage.getItem("token");

const socket = io(process.env.REACT_APP_SOCKET_URL, {
  transports: ["websocket"],
  auth: {
    token: token,
    role: "admin",
  },
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
});

socket.on("connect", () => {
  console.log("✅ Connected to WebSocket:", socket.id);
});

socket.on("disconnect", () => {
  console.log("❌ Disconnected from WebSocket");
});

socket.on("connect_error", (err) => {
  console.error("⚠️ Connection Error:", err.message);
});

export default socket;
